import { MainGrid } from './main-page.styles';

interface ChildComponents {
  children: JSX.Element;
}

export function MainPage({ children }: ChildComponents): JSX.Element {
  return <MainGrid>{children}</MainGrid>;
}
